import React, { useState } from 'react';
import { Modal, Button } from "tea-component";
import './index.scss';


export default function TextActivities(props: any) {
  const { text, title } = props;
  const [isShow, setShow] = useState(false);

  return (
    <>
      <div className="dbi-market-textactivities">
        {/* isShow ? 'dbi-market-title-show' : 'dbi-market-title-noshow' */}
        <div className="dbi-market-textactivities-text">
          <label
            className="dbi-market-textactivities-btn"
            htmlFor="exp"
            onClick={() => {
              setShow(!isShow);
            }}
          >
            {/* {isShow ? 'Less All' : 'More'} */}
            more
          </label>
          <span dangerouslySetInnerHTML={{ __html: text }}></span>
        </div>
      </div>

      {/* 弹窗 */}
      <Modal
        className='dbi-market-textactivities-modal'
        caption={title}
        visible={isShow}
        onClose={() => { setShow(!isShow) }}
      >
        <Modal.Body>
          <div className='modal-cont' dangerouslySetInnerHTML={{ __html: text }}>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
